:host {
    --muse-base-unit: 1.6rem;

    muse-header {
        position: relative;
        --muse-hotfix-header-z-index: 500;
    }

    muse-header header {
        display: inline-block;
    }

    muse-language-switch {
        position: relative;
    }

    muse-context-menu {
        position: relative;
    }

    display: block;
    font-family: 'Fira Sans',
    sans-serif;

    c-header::part(c-header) {
        margin-top: 0;
        margin-bottom: 1.8rem;
    }

    .age-info {
        display: block;
        line-height: 1.6rem;

        .info-icon {
            box-sizing: border-box;
            position: relative;
            display: inline-block;
            width: 18px;
            height: 18px;
            border: 0.15rem solid #333;
            border-radius: 36px;
            font-style: normal;
            text-align: center;
            font-family: 'Fira Sans', sans-serif;
            font-size: 1.4rem;
            line-height: 1.5rem;
            font-weight: bold;
            margin-right: 1rem;
        }
    }




    a.link {
        float: right;
        font-size: 1.8rem;
        font-style: italic;
        text-decoration: none;
        padding: 16px 4px 0 0;
        line-height: 1.3333333333;
        border-bottom: 1px solid #0a171f;

        &:hover {
            border-bottom-color: transparent;
        }
    }

    .dse-link {
        padding: 3px 0;

        c-button {
            font-style: italic;
        }

    }

    c-button.right {
        float: right;
    }

    c-container.keep-alive-warning {
        position: sticky;
        top: 0;
        z-index: 450;
        animation: fadein 2s;
        max-width: 100%;
        margin: 0;
    }

    lb-tmp-save {
        display: block;
        margin-right: 300px;
    }

    @media (max-width: 768px) {
        lb-tmp-save {
            margin-right: 0;
        }
    }

    @media (min-width: 1440px) {
        lb-tmp-save {
            margin-right: 450px;
        }
    }

    @keyframes fadein {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }

    .confirm-buttons {
        overflow: visible;
        padding-top: 40px;
    }


    c-breadcrumb {
        margin-bottom: 40px;
    }

    muse-header a img {
        height: 100%;
    }

    p-meta-links {
        display: block;
        width: calc(100% - 250px);
        line-height: 1;
    }


    // header banner

    .header-banner {
        line-height: calc(1.1875 * var(--muse-base-unit, 1rem));
        font-family: Fira Sans, sans-serif;
        font-size: calc(1 * var(--muse-base-unit, 1rem));
        font-weight: 400;
        line-height: 24px;
        display: flex;
        justify-content: center;
        background: #f0f0f0
    }

    @media (width < 768px) {
        .header-banner {
            line-height: calc(1.25 * var(--muse-base-unit, 1rem));
            font-family: Fira Sans, sans-serif;
            font-size: calc(.875 * var(--muse-base-unit, 1rem));
            font-weight: 400
        }
    }

    .header-banner>div {
        display: flex;
        align-items: center;
        gap: 1rem;
        max-width: 1200px;
        width: 100%;
        margin: 0 64px
    }

    @media (width < 768px) {
        .header-banner>div[data-v-3ff9ebc4] {
            margin: 0 20px
        }
    }

    .header-banner>div>img {
        height: 16px;
        width: auto;
        margin-top: 2.4px;
        align-self: flex-start;
        border: solid 1px #fff
    }

    .header-banner>div>p {
        margin: 0
    }

    @media (width < 768px) {
        .header-banner>div>p {
            font-size: 16px;
            line-height: 24px
        }
    }

}